
import { defineComponent, computed } from 'vue'
import { useStore } from '@/store'

export default defineComponent({
  setup () {
    const store = useStore()

    const message = computed(() => store.state.message)
    const messageType = computed(() => store.state.messageType)
    const messageTypeClass = computed(() => {
      return messageType.value === 'error' ? 'flash-message--error' : 'flash-message--success'
    })

    const hide = () => {
      store.dispatch('hideMessage')
    }

    return { message, messageTypeClass, hide }
  }
})
